import React from 'react';
import { UTCard, UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';
import Grid from '@material-ui/core/Grid';
import { string, func, bool, number } from 'prop-types';

import { message } from 'utils/stringUtils';

import { ReactComponent as Done } from './assets/done.svg';
import styles from './styles.module.scss';

const CardOfficeContainer = ({ name, address, id, selected, onClick }) => {
  const handleOnClick = () => onClick(id);
  return (
    <Grid item xs={12} md={6}>
      <UTTouchableWithoutFeedback className={styles.generalContainer} onClick={handleOnClick}>
        <UTCard className={`${styles.card} ${selected && styles.cardSelect}`} flat>
          <div className={`${styles.radio} ${selected && styles.radioSelect}`}>{selected && <Done />}</div>
          <div className={styles.labelContainer}>
            <UTLabel className={`${styles.label} ${selected && styles.labelSelected}`} darkGray>
              **{message('Commons:office').toUpperCase()} {name}**
            </UTLabel>
            <UTLabel className={`${styles.label} ${selected && styles.labelSelected}`} darkGray>
              {address}
            </UTLabel>
          </div>
        </UTCard>
      </UTTouchableWithoutFeedback>
    </Grid>
  );
};

CardOfficeContainer.propTypes = {
  name: string,
  address: string,
  id: number,
  selected: bool,
  onClick: func
};

export default CardOfficeContainer;
